import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: React.ReactNode;
  container?: Element;
}

/**
 * Portal组件
 * 将子元素渲染到DOM树中的指定节点，默认为document.body
 */
export const Portal: React.FC<PortalProps> = ({ 
  children, 
  container = typeof document !== 'undefined' ? document.body : undefined 
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  // 在服务器端渲染或挂载前不渲染任何内容
  if (!mounted || !container) return null;

  // 使用createPortal将子元素渲染到指定容器
  return createPortal(children, container);
};

export default Portal;
